// libraries
import { useState } from 'react';
import { BackTop } from 'antd';
import styled from 'styled-components';

// components
import { GroupListHeader } from './group-list-header';
import { GroupListContentDesktop } from './group-list-content.desktop';
import { GroupListContentMobile } from './group-list-content.mobile';

// hooks
import { useDeviceSize } from '../../../../hooks/device-size';

export function GroupList(): JSX.Element {
	const [dataSource, setDataSource] = useState<Record<string, any>[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const isMobileDevice: boolean = useDeviceSize();

	return (
		<StyledMain>
			<GroupListHeader setDataSource={setDataSource} useLoading={[loading, setLoading]} />
			{isMobileDevice === false && <GroupListContentDesktop dataSource={dataSource} loading={loading} />}
			{isMobileDevice === true && <GroupListContentMobile dataSource={dataSource} loading={loading} />}
			<BackTop target={(): any => document.querySelector('main')} />
		</StyledMain>
	);
}

const StyledMain = styled.main`
	display: flex;
	flex-direction: column;
	position: relative;
`;
